import React from 'react';
import { MapPin, Mail, Clock } from 'lucide-react';

const ContactSection = () => {
  const sectionStyle = {
    padding: '5rem 1.5rem',
    position: 'relative'
  };

  const containerStyle = {
    maxWidth: '72rem',
    margin: '0 auto'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '4rem'
  };

  const titleStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '1.5rem'
  };

  const highlightStyle = {
    color: '#dfa926'
  };

  const descriptionStyle = {
    fontSize: '1.25rem',
    color: '#d1d5db',
    maxWidth: '32rem',
    margin: '0 auto'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '3rem'
  };

  const cardStyle = {
    background: 'linear-gradient(135deg, rgba(26, 26, 26, 0.5) 0%, rgba(17, 17, 17, 0.5) 100%)',
    padding: '2rem',
    borderRadius: '0.75rem',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(58, 58, 58, 0.5)'
  };

  const cardTitleStyle = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '2rem',
    textAlign: 'left'
  };

  const contactItemStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    marginBottom: '1.5rem'
  };

  const iconStyle = {
    width: '1.5rem',
    height: '1.5rem',
    color: '#dfa926',
    flexShrink: 0,
    marginTop: '0.25rem'
  };

  const contactTitleStyle = {
    color: 'white',
    fontWeight: '600',
    marginBottom: '0.25rem',
    textAlign: 'left'
  };

  const contactTextStyle = {
    color: '#d1d5db',
    lineHeight: '1.6',
    textAlign: 'left'
  };

  const whyContactStyle = {
    background: 'linear-gradient(135deg, rgba(223, 169, 38, 0.1) 0%, rgba(223, 169, 38, 0.05) 100%)',
    padding: '2rem',
    borderRadius: '0.75rem',
    border: '1px solid rgba(223, 169, 38, 0.2)',
    marginTop: '2rem'
  };

  const listStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0
  };

  const listItemStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.75rem',
    color: '#d1d5db'
  };

  const bulletStyle = {
    width: '0.5rem',
    height: '0.5rem',
    backgroundColor: '#dfa926',
    borderRadius: '50%',
    marginRight: '0.75rem'
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  };

  const formRowStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1.5rem'
  };

  const labelStyle = {
    display: 'block',
    color: 'white',
    fontWeight: '500',
    marginBottom: '0.5rem'
  };

  const inputStyle = {
    width: '100%',
    backgroundColor: 'rgba(58, 58, 58, 0.5)',
    border: '1px solid #4b5563',
    color: 'white',
    borderRadius: '0.5rem',
    padding: '0.75rem 1rem',
    transition: 'border-color 0.3s'
  };

  const textareaStyle = {
    ...inputStyle,
    resize: 'vertical',
    minHeight: '120px'
  };

  const buttonStyle = {
    width: '100%',
    backgroundColor: '#dfa926',
    color: 'black',
    fontWeight: '600',
    padding: '1rem',
    borderRadius: '0.5rem',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>
            Get In <span style={highlightStyle}>Touch</span>
          </h2>
          <p style={descriptionStyle}>
            Ready to discuss your exterior door needs? Contact us today for a consultation.
          </p>
        </div>

        <div style={gridStyle}>
          {/* Contact Information */}
          <div>
            <div style={cardStyle}>
              <h3 style={cardTitleStyle}>Contact Information</h3>

              <div>
                <div style={contactItemStyle}>
                  <MapPin style={iconStyle} />
                  <div>
                    <h4 style={contactTitleStyle}>Address</h4>
                    <p style={contactTextStyle}>
                      Hestia Doors OÜ<br />
                      Päikese 1<br />
                      30221 Kohtla-Järve<br />
                      Estonia
                    </p>
                  </div>
                </div>

                <div style={contactItemStyle}>
                  <Mail style={iconStyle} />
                  <div>
                    <h4 style={contactTitleStyle}>Email</h4>
                    <p style={contactTextStyle}>info@hestiadoors.com</p>
                  </div>
                </div>

                <div style={contactItemStyle}>
                  <Clock style={iconStyle} />
                  <div>
                    <h4 style={contactTitleStyle}>Business Hours</h4>
                    <p style={contactTextStyle}>
                      Monday - Friday: 8:00 AM - 6:00 PM<br />
                      Saturday: 9:00 AM - 4:00 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div style={whyContactStyle}>
              <h3 style={{ ...cardTitleStyle, fontSize: '1.25rem' }}>Why Contact Us?</h3>
              <ul style={listStyle}>
                <li style={listItemStyle}>
                  <span style={bulletStyle}></span>
                  <span>Free consultation and quote</span>
                </li>
                <li style={listItemStyle}>
                  <span style={bulletStyle}></span>
                  <span>Expert advice on door selection</span>
                </li>
                <li style={listItemStyle}>
                  <span style={bulletStyle}></span>
                  <span>Custom solutions available</span>
                </li>
                <li style={listItemStyle}>
                  <span style={bulletStyle}></span>
                  <span>Professional installation service</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div style={cardStyle}>
            <h3 style={cardTitleStyle}>Send us a Message</h3>

            <form style={formStyle}>
              <div style={formRowStyle}>
                <div>
                  <label style={labelStyle}>First Name</label>
                  <input 
                    type="text" 
                    style={inputStyle}
                    placeholder="Your first name"
                    onFocus={(e) => e.target.style.borderColor = '#dfa926'}
                    onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Last Name</label>
                  <input 
                    type="text" 
                    style={inputStyle}
                    placeholder="Your last name"
                    onFocus={(e) => e.target.style.borderColor = '#dfa926'}
                    onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                  />
                </div>
              </div>

              <div>
                <label style={labelStyle}>Email</label>
                <input 
                  type="email" 
                  style={inputStyle}
                  placeholder="your.email@example.com"
                  onFocus={(e) => e.target.style.borderColor = '#dfa926'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
              </div>

              <div>
                <label style={labelStyle}>Phone Number</label>
                <input 
                  type="tel" 
                  style={inputStyle}
                  placeholder="+372 XXXX XXXX"
                  onFocus={(e) => e.target.style.borderColor = '#dfa926'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
              </div>

              <div>
                <label style={labelStyle}>Subject</label>
                <input 
                  type="text" 
                  style={inputStyle}
                  placeholder="Door inquiry"
                  onFocus={(e) => e.target.style.borderColor = '#dfa926'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
              </div>

              <div>
                <label style={labelStyle}>Message</label>
                <textarea 
                  style={textareaStyle}
                  placeholder="Tell us about your door requirements..."
                  onFocus={(e) => e.target.style.borderColor = '#dfa926'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                ></textarea>
              </div>

              <button 
                type="submit"
                style={buttonStyle}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#c8941f';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#dfa926';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
